/**
 * Filter implementation types
 * @enum {string}
 */
export const FilterType = {
    API: 'API',
    CUBE: 'Cube'
};
